import { IClipboardData, ICopyInfo, CopyElementType } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUndoRedoService } from '@src/slide/application/service/undo-redo-service/undo-redo-service.interface';
import { IPasteSpecialServiceDelegates, IPasteSpecialStrategy } from './interface';
import { SlideSdkDataModify } from '@src/slide/application/service/copy-paste/core/paste/slide-sdk-data-modify';
import { IPcCopyPaste } from '@src/slide/application/service/copy-paste/core/pc/pc-copy-paste.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { ITextSelectionUndoRedo } from '@src/slide/application/service/text-selection-undo-redo/interface';
import { ITextSelectivePasteState } from '@src/slide/application/service/text-selective-paste-state/interface';

// 具体策略类基类
export default class BasePasteSpecial implements IPasteSpecialStrategy {
    // 剪贴板数据
    protected clipboardData: IClipboardData;
    // 复制元素的类型
    protected type: CopyElementType;
    // 处理slide缩放等
    protected slideSdkDataModify: SlideSdkDataModify;
    // 选中元素service
    protected selectionService?: ISelectionService;
    // 撤销重做service
    protected undoRedoService?: IUndoRedoService;
    // 复制粘贴 service
    protected copyPasteManager?: IDynamicService<IPcCopyPaste>;
    // 文本选区 undo redo service
    protected textSelectionUndoRedo?: ITextSelectionUndoRedo;
    // 文本选择性粘贴状态
    protected textSelectivePasteState?: ITextSelectivePasteState;
    // 插入幻灯片的位置，不包含节
    protected insertSlideIndex?: number;
    // 插入幻灯片的位置，包含节
    protected insertGapIndex?: number;

    public constructor(copyInfo: ICopyInfo, serviceDelegates: IPasteSpecialServiceDelegates) {
        this.clipboardData = copyInfo.clipboardData;
        this.type = copyInfo.type;
        this.insertSlideIndex = copyInfo.insertSlideIndex;
        this.insertGapIndex = copyInfo.insertGapIndex;
        this.selectionService = serviceDelegates.selectionService;
        this.undoRedoService = serviceDelegates.undoRedoService;
        this.copyPasteManager = serviceDelegates.copyPasteManager;
        this.textSelectionUndoRedo = serviceDelegates.textSelectionUndoRedo;
        this.textSelectivePasteState = serviceDelegates.textSelectivePasteState;
        this.slideSdkDataModify = new SlideSdkDataModify();
        this.slideSdkDataModify.setServiceDelegates({
            uiDataService: serviceDelegates.uiDataService,
            selectionService: this.selectionService,
        });
    }

    public paste() {}
}
